import { put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { reset } from 'redux-form';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';
import { getText, getRedirectUrl, getBankIdPopupData } from 'misc/helpers';
import { popup_icon_type } from 'components/shared/popup/Popup';
import { accessDigimail } from './sessions';

export function* getCustomer(action) {
    try {
        const response = yield endpoint.get('customer/' + action.customerId);

        let customerData = response.data;

        let redirectUrl = getRedirectUrl();

        if (action.redirect && redirectUrl) {
            // If redirecting to envelope then fetch inbox first
            if (redirectUrl.startsWith('/inbox/')) {
                let envelopeInfo = redirectUrl.split('/');
                customerData.redirectEnvelopeId = envelopeInfo[envelopeInfo.length - 1];
                redirectUrl = '/inbox';
            } else if (redirectUrl.startsWith('/archives/')) {
                let envelopeInfo = redirectUrl.split('/');
                customerData.redirectEnvelopeId = envelopeInfo[envelopeInfo.length - 1];
                redirectUrl = '/archives';
            }
        }

        // Remove spaces from customer email, because backend used to allow it
        if (customerData.email) {
            customerData.email = customerData.email.trim();
        }

        yield put({ type: types.SAGA_CUSTOMER_GET.SUCCESS, payload: customerData });

        if (action.redirect) {
            // If this happens at login, do extra checks and redirect

            // If has pending email then send to verify
            if (response.data.pendingEmail || !response.data.email) {
                if (redirectUrl) {
                    // Be sure to keep redirect route
                    redirectUrl = '/verify/redirect' + redirectUrl;
                } else {
                    redirectUrl = '/verify/redirect/inbox';
                }
            } else {
                if (!redirectUrl) {
                    redirectUrl = '/inbox';
                }
            }

            yield put(push(redirectUrl));
        }
    } catch (error) {
        yield put({ type: types.SAGA_CUSTOMER_GET.FAILURE, error });
    }
}

export function* postCustomer(action) {
    if (!action.payload.agree) {
        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                header: '',
                text: getText('Missing', 'Du måste godkänna villkoren för att kunna skapa ett konto')
            }
        });

        yield put({ type: types.SAGA_CUSTOMER_POST.FAILURE, error: 'Användare godkände inte avtal' });
    } else {
        // Show Bank ID popup
        yield put(getBankIdPopupData(types.SAGA_CUSTOMER_POST, getText('Missing', 'Användare avbröt registrering')));

        try {
            const response = yield endpoint.post('customer/', {
                governmentId: action.payload.personnr,
                email: action.payload.email,
                phone: action.payload.phone
            });

            if (response.status === 202) {
                // Create account ok
                let bankidResponse = yield endpoint.location(response.data.signatureUrl);

                yield put({ type: types.POPUP_HIDE });
                yield put({ type: types.SAGA_CUSTOMER_POST.SUCCESS, payload: {} });

                // Login
                yield put({ type: types.SAGA_LOGIN.SUCCESS, payload: { customerId: bankidResponse.data.customerId } });

                yield accessDigimail(bankidResponse.data.customerId, false);

                yield put(reset('RegisterForm'));

                yield put(push('/Welcome'));
            }
        } catch (error) {
            if (error.response && error.response.status === 409) {
                // Account already exists
                yield put({
                    type: types.POPUP_SHOW,
                    payload: {
                        show: true,
                        icon: popup_icon_type.error,
                        header: getText('Missing', 'Konto finns redan'),
                        text: getText('Missing', 'Det personnummer du matat in har redan ett konto hos Digimail.')
                    }
                });
            } else {
                yield put({ type: types.POPUP_HIDE });
            }

            yield put({ type: types.SAGA_CUSTOMER_POST.FAILURE, error });
        }
    }
}

export function* putCustomer(action) {
    let customer = action.payload;

    const redirectUrl = customer.redirectUrl;

    try {
        const response = yield endpoint.put('customer/' + customer.id, customer);

        yield put({ type: types.SAGA_CUSTOMER_PUT.SUCCESS, payload: response.data });

        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.none,
                header: getText('_12_1_TitelDataSaved', 'Dina uppgifter är sparade.'),
                text: getText(
                    '_12_1_TextDataSaved',
                    'Om du angett en ny e-postadress så har vi skickat ut ett verifieringsmail till dig. Du behöver klicka på länken för att e-postadressen ska uppdateras. Fram tills dess du verifierat din nya adress kommer den gamla att gälla.'
                )
            }
        });

        if (redirectUrl) {
            yield put(push(redirectUrl));
        }
    } catch (error) {
        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                text: error.response.data.message
            }
        });
        yield put({ type: types.SAGA_CUSTOMER_PUT.FAILURE, error });
        yield put({ type: types.SAGA_CUSTOMER_GET.REQUEST, customerId: customer.id });
    }
}

export function* deleteCustomer(action) {
    try {
        // Show Bank ID popup
        yield put(getBankIdPopupData(types.SAGA_CUSTOMER_DELETE, getText('Missing', 'Användare avbröt avslut')));

        const response = yield endpoint.remove('customer/' + action.customerId);

        if (response.status === 202) {
            yield endpoint.location(response.data.signatureUrl);
            yield put({ type: types.SAGA_CUSTOMER_DELETE.SUCCESS, payload: {} });
        }

        yield put({ type: types.POPUP_HIDE });

        yield put({ type: types.SAGA_LOGOUT.REQUEST, redirect: '/goodbye' });
    } catch (error) {
        yield put({ type: types.SAGA_CUSTOMER_DELETE.FAILURE, error });

        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                header: '',
                text: error.message
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/sagas/customer.js